import BaseCache from './base';

export default class LocalStorageCache extends BaseCache {
  constructor() {
    super(window.localStorage);
  }
}
